var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"absolute","top":"40%","left":"50%","transform":"translate(-50%, -50%)","width":"60%","height":"60%"},attrs:{"id":"tour2"}})
}
var staticRenderFns = []

export { render, staticRenderFns }